import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { PlanDetailsRenderableGroup } from '../../../../types/plan-details.types';

@Component({
    selector: 'app-prescription-drug-tiers',
    templateUrl: './prescription-drug-tiers.component.html',
    styleUrls: ['./prescription-drug-tiers.component.scss'],
    standalone: false
})
export class PrescriptionDrugTiersComponent implements OnInit {
  @Input() benefitGroup: PlanDetailsRenderableGroup;
  deliveryTypeForm: UntypedFormGroup;

  /** PRESCRIPTION DRUG SPECIFIC VALUES */
  prescriptionDrugSelectOptions = [
    { id: 'preferredRetail', label: 'Preferred Retail drug cost for 1-month delivery' },
    { id: 'standardRetail', label: 'Standard Retail drug cost for 1-month delivery' },
    { id: 'preferredMail', label: 'Preferred Mail drug cost for 3-month delivery' },
    { id: 'standardMail', label: 'Standard Mail drug cost for 3-month delivery' },
  ];
  selectionChoice = this.prescriptionDrugSelectOptions[0].id;

  constructor(private fb: UntypedFormBuilder) {
    this.deliveryTypeForm = this.fb.group({
      deliveryOption: this.fb.control(this.prescriptionDrugSelectOptions[0].id)
    });
  }

  ngOnInit() { }

  getPlanNameByPlanId(planId: string) {
    const matchedPlans = this.benefitGroup.plans.filter(planMeta => planMeta.id === planId);
    if (matchedPlans.length > 0) {
      return matchedPlans[0].name;
    }
    return '';
  }

}
